module.exports = __webpack_public_path__ + "img/8.81ec945f.jpg";